/*
 * ---------------------------------------------------------------------------
 * AI-GENERATED CODE
 * This file was generated by Kiro (Claude Opus 4.8) as an AI-generated utility.
 * Review before relying on it in production.
 * ---------------------------------------------------------------------------
 */

/**
 * Suppresses a specific, well-known class of noise emitted by *browser extensions*
 * (content scripts) — NOT by this application.
 *
 * Symptom seen in the console/logs:
 *   Uncaught (in promise) Error: Could not establish connection. Receiving end does not exist.
 *
 * This is thrown by the Chrome/Edge extension messaging API
 * (`chrome.runtime.sendMessage` / `chrome.tabs.sendMessage`) when an extension's
 * injected content script tries to message its background service worker and nothing
 * is listening (the MV3 worker went idle, the page navigated mid-flight, or the
 * extension was updated/disabled). It surfaces as an *unhandled promise rejection*
 * on `window`, so it never reaches Angular's ErrorHandler, and it has nothing to do
 * with our code.
 *
 * SCOPING: We match ONLY the exact extension messaging signatures below. Anything
 * else — including our own HTTP failures, iframe-bridge errors, or any rejection
 * that merely contains the word "connection" — is left completely untouched so real
 * errors still surface.
 */

// Exact messages produced by the extension messaging API. Kept as an explicit,
// closed allow-list so unrelated rejections are never swallowed.
const EXTENSION_ERROR_MESSAGES: readonly string[] = [
  'Could not establish connection. Receiving end does not exist.',
  'The message port closed before a response was received.'
];

function extractMessage(reason: unknown): string | undefined {
  if (typeof reason === 'string') {
    return reason;
  }
  if (reason instanceof Error && typeof reason.message === 'string') {
    return reason.message;
  }
  if (
    reason !== null &&
    typeof reason === 'object' &&
    typeof (reason as { message?: unknown }).message === 'string'
  ) {
    return (reason as { message: string }).message;
  }
  return undefined;
}

function isBrowserExtensionMessagingError(reason: unknown): boolean {
  const Message = extractMessage(reason);
  if (!Message) {
    return false;
  }
  // Exact-match only; do not do loose `includes` on partial fragments so we cannot
  // accidentally hide an application error that happens to mention "connection".
  return EXTENSION_ERROR_MESSAGES.some(Known => Message === Known);
}

/**
 * Registers a narrowly-scoped `unhandledrejection` listener that silences only the
 * browser-extension messaging noise described above. Safe to call once at bootstrap.
 */
export function installBrowserExtensionErrorGuard(target: Window = window): void {
  target.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    if (isBrowserExtensionMessagingError(event.reason)) {
      // Stop it from reaching the console / any downstream telemetry. Everything
      // that does not match the exact signatures falls through untouched.
      event.preventDefault();
    }
  });
}
